import { render, staticRenderFns } from "./PdpReviewsSummary.vue?vue&type=template&id=18ac8481&"
import script from "./PdpReviewsSummary.vue?vue&type=script&lang=js&"
export * from "./PdpReviewsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports